import {Badge} from "antd";
import {DownCircleOutlined, RetweetOutlined, CloseCircleOutlined} from '@ant-design/icons';

import {createSort} from "../../shared/utilities/sortFunctions";

const statusIcon = {
    accepted: <DownCircleOutlined className="accepted-icon"/>,
    wait: <RetweetOutlined className="wait-icon"/>,
    rejected: <CloseCircleOutlined className="rejected-icon"/>,
};

 const columns = [
    {
        title: 'Title',
        dataIndex: 'title',
        key: 'title',
        sorter: (a, b) => a.title.localeCompare(b.title),
        width: "40%",
    },
    {
        title: 'Requestor',
        dataIndex: 'requestor',
        key: "requestor",
        responsive: ['md'],
        sorter: (a, b) => a.requestor.localeCompare(b.requestor),
    },
    {
        title: 'Date',
        dataIndex: 'date',
        key: "date",
        responsive: ['lg'],
        sorter: (a, b) => a.date.localeCompare(b.date),
    },
    {
        title: 'Status',
        dataIndex: 'status',
        key: "status",
        filters: [
            {
                text: 'New',
                value: 'new',
            },
            {
                text: 'Open',
                value: 'open',
            },
            {
                text: 'Closed',
                value: 'closed',
            },
        ],
        sorter: (a, b) => a.status.localeCompare(b.status),
        // onFilter: (value, record) => record.status.includes(value),
        // render: (text) => <div className="table-status">{statusIcon[text]}</div>,
    },
    {
        title: '',
        dataIndex: 'details',
        key: "details",
    },
];

export default columns;
